import { FC, ReactNode } from 'react';
import { NotificationType } from '../../types';
import styles from './notification-message.module.scss';
import { classSet, Icon } from '@platform/ui-library';
import { IconType } from '@platform/ui-library/build/Icon';

const typeToIcon: Record<NotificationType, IconType> = {
  [NotificationType.error]: 'errorColor',
  [NotificationType.info]: 'infoColor',
  [NotificationType.success]: 'successColor',
  [NotificationType.warning]: 'warningColor'
};

export type NotificationMessageProps = {
  children: ReactNode;
  type: NotificationType;
};

export const NotificationMessage: FC<NotificationMessageProps> = ({
  children,
  type
}) => {
  const icon = typeToIcon[type];

  return (
    <p className={classSet([styles.container, styles[type]])}>
      {(!icon) ? null : (
        <Icon icon={icon} />
      )}
      <span>{children}</span>
    </p>
  );
};
